<template>
    <div class="container remove-padding-margin">
        <div class="fixed-top fixed-judul">
            <div class="row justify-content-center align-items-center set-row">
                <dnpmiv class="col-md-1 col-sm-1 col-1 remove-padding" @click="back">
                    <img src="../../assets/gambar/back-blue.svg" alt="">
                </dnpmiv>
                <div class="col-md-10 col-sm-10 col-10 text-center remove-padding">Ubah Paket Deposit</div>
                <div class="col-md-1 col-sm-1 col-1 remove-padding">
                </div>
            </div>
        </div>
        <main class="add-padding-default">
            <div class="flex-100">
                <div class="flex-1">
                    <form action="">
                        <div class="form-group set-margin">
                            <label class="remove-margin require color-label" for="namadeposit">Nama Paket
                                Deposit</label>
                            <input type="text" class="form-control inputs mar-bot-12" id="namadeposit"
                                   aria-describedby="emailHelp"
                                   placeholder="Cuci Kering Setrika" v-model="Nama_Paket_Deposit"
                                   v-on:keyup="nameonly">
                            <ErrorMessage class="error" label="Nama Paket Deposit"
                                          :validation="$v.Nama_Paket_Deposit"></ErrorMessage>
                            <label class="remove-margin require color-label">Layanan Yang Terhubung</label>
                            <Select2 class="test-select fl-is-required inputs mod" id="select2" v-on:change="hitungfunc"
                                     v-model="selectedlayananedit" :options="optionslayananedit"
                                     :settings="{ placeholder: 'Pilih Layanan' }"
                                     @change="myChangeEvent($event)"/>
                            <ErrorMessage class="error" label="Layanan Yang Terhubung"
                                          :validation="$v.selectedlayananedit"></ErrorMessage>
                            <div class="form-row">
                                <div class="form-group col-md-6 col-sm-6 col-6">
                                    <label class="remove-margin mar-top-12 require color-label" for="paket">Isi
                                        Paket</label>
                                    <div class="input-group remove-padding">
                                        <input type="tel" class="form-control inputs" id="paket"
                                               placeholder="0" v-model="Paket" v-on:keyup="onlynumberpaket">
                                        <div class="input-group-prepend">
                                            <div class="input-group-text">{{satuan}}</div>
                                        </div>
                                    </div>
                                    <ErrorMessage class="error" label="Isi Paket"
                                                  :validation="$v.Paketcuk"></ErrorMessage>
                                </div>
                                <div class="form-group col-md-6 col-sm-6 col-6">
                                    <label class="remove-margin mar-top-12 color-label">Diskon</label>
                                    <div class="input-group remove-padding">
                                        <!--<input type="tel" class="form-control inputs" id="diskon" placeholder="0" value="0"-->
                                        <!--       v-model="Diskon" v-on:keyup="onlynumberdiskon">-->
                                        <InputPersentase id="diskonId" v-model="Diskon" :defaultValue="Diskon.raw"
                                                         :class="'form-control inputs'"/>
                                        <div class="input-group-prepend">
                                            <div class="input-group-text">%</div>
                                        </div>
                                    </div>
                                    <ErrorMessage class="error" label="Diskon"
                                                  :validation="$v.Diskon.raw"></ErrorMessage>
                                    <!--	                                {{ Diskon }}-->
                                </div>
                            </div>
                            <!--                            <label class="remove-margin require color-label" for="masaaktif">-->
                            <!--	                            Masa Aktif-->
                            <!--	                            <i class="fas fa-question-circle"-->
                            <!--	                               id="tooltip-masa-aktif"-->
                            <!--	                               data-toggle="tooltip" data-placement="right" data-html="true"-->
                            <!--	                               title="Masa aktif paket deposit bersifat akumulasi. <br>-->
                            <!--		                            Ketika customer membeli paket deposit berkali-kali maka masa aktif semakin panjang. Ketika expired saldo deposit akan hilang/hangus"-->
                            <!--	                            ></i>-->
                            <!--                            </label>-->
                            <!--                            <div class="input-group remove-padding">-->
                            <!--                                <input type="tel" class="form-control inputs" id="masaaktif" placeholder="0" value="0"-->
                            <!--                                       v-model="Masa_aktif" v-on:keyup="onlynumberdurasi">-->
                            <!--                                <div class="input-group-prepend">-->
                            <!--                                    <div class="input-group-text">Hari</div>-->
                            <!--                                </div>-->
                            <!--	                            <span id="penjelasan-masa-aktif" style="display: none">-->
                            <!--		                            Masa aktif paket deposit bersifat akumulasi. <br>-->
                            <!--		                            Ketika customer membeli paket deposit berkali-kali maka masa aktif semakin panjang. Ketika expired saldo deposit akan hilang/hangus-->
                            <!--	                            </span>-->
                            <!--                            </div>-->
                            <label class="remove-margin mar-top-12 require color-label" for="hargaPaket">Harga
                                Paket</label>
                            <div class="input-group remove-padding">
                                <div class="input-group-prepend">
                                    <div class="input-group-text">Rp</div>
                                </div>
                                <input type="tel" class="form-control inputs" id="hargaPaket" placeholder="14.000"
                                       disabled v-model="Harga_Paket" v-on:keyup="formatrupiahcreatehargalayanan">
                            </div>

                            <div class="custom-control custom-switch mar-top-20" style="padding: 0px 12px"
                                 id="tooglemasaaktif" @click="masaaktiftoogle">
                                <input type="checkbox" class="custom-control-input" id="customSwitch3">
                                <label class="custom-control-label color-33333 font-weight-bold" for="customSwitch3"
                                       id="label-durasi">
                                    Aktifkan Masa Aktif
                                </label>
                            </div>
                            <div id="masaaktif">
                                <label class="remove-margin mar-top-12" for="durasi">
                                    Masa Aktif Paket
                                </label>
                                <div class="input-group remove-padding">
                                    <input type="tel" class="form-control inputs" id="durasi" value="0" placeholder="30"
                                           v-model="Masa_aktif" v-on:keyup="onlynumberdurasi">
                                    <div class="input-group-prepend">
                                        <div class="input-group-text">Hari</div>
                                    </div>
                                </div>
                                <ErrorMessage class="error" label="Masa Aktif Paket"
                                              :validation="$v.Masa_aktif"></ErrorMessage>
                                <p class="m-t-4 f-12 f-c-midgrey">
                                    Masa aktif bersifat akumulatif, sehingga jika konsumen membeli paket sekali lagi,
                                    maka masa aktif bertambah.
                                    Jika masa aktif telah habis, maka saldo paket hangus.
                                </p>
                            </div>
                        </div>
                    </form>
                </div>
                <div class="button-lanjut ">
                    <button class="btn btn-login btn-long remove-margin" id="btnSimpanEditDeposit" @click="editdeposit">
                        <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"
                              v-if="isClicked1 === true"></span>
                        <span id="textBtn2">Simpan</span>
                    </button>
                </div>
            </div>
        </main>
    </div>
</template>

<script>
    import Select2 from 'v-select2-component';
    import InputPersentase from "../../component-items/InputPersentase";
    import ErrorMessage from "@/component-items/ErrorMessage";
    import {minValue, minLength, required} from "vuelidate/lib/validators";

    export default {
        name: "EditDeposit",
        components: {Select2, InputPersentase, ErrorMessage},
        props: ['setidoutletsetdeposit', 'dataiddeposit'],
        data() {
            return {
                deposit: [],
                iddeposit: '',
                idoutlet: this.setidoutletsetdeposit,
                Nama_Paket_Deposit: '',
                Paket: '',
                Paketcuk: '',
                satuan: '',
                Diskon: {
                    raw: 0,
                    formatted: "",
                },
                HargaLayanan: '',
                Masa_aktif: 0,
                Harga_Paket: '',
                Harga_Paket_Diskon: '',
                selectedlayananedit: '',
                optionslayananedit: [],
                isClicked: false,
                isClicked1: false,
                requestHeaders: {
                    headers: {
                        'Authorization': 'Bearer ' + localStorage.getItem('token'),
                    }
                },
            }
        },
        validations: {
            Nama_Paket_Deposit: {
                required,
                minLength: minLength(2),
            },
            selectedlayananedit: {
                required,
            },
            Paketcuk: {
                required,
                minValue: minValue(1)
            },
            Diskon: {
                raw: {
                    required,
                }
            },
            Masa_aktif: {
                required,
                minValue: minValue(1)
            }
        },
        mounted() {
            this.idoutlet = this.$route.params.idoutlet
            this.iddeposit = this.$route.params.iddeposit
            this.getlayananselect()
            this.detaildeposit()
            // this.penjelasanMasaAktif()

            $('#tooltip-masa-aktif').tooltip()
            $('#masaaktif').hide()
            this.backButtonPressed(this.back)
        },
        watch: {
            "Diskon.raw": function () {
                this.hitungfunc()
            },
            immediate: true
        },
        methods: {
            onlynumberpaket(event) {
                var nums = event.target.value;
                var number = nums.replace(/[^0-9,]+/, '');
                this.Paket = number
                if (number.length >= 3) {
                    if (number.includes(",")) {
                        var dataNum = number.split(",")
                        if (dataNum[0].length >= 3) {
                            this.$toast.warning("Isi paket terlalu banyak. Apakah anda yakin untuk mengisi paket sebanyak itu?")
                        }
                    } else {
                        this.$toast.warning("Isi paket terlalu banyak. Apakah anda yakin untuk mengisi paket sebanyak itu?")
                    }
                }

                if (number.includes(",")) {
                    this.Paket = this.splitTextString(number);
                    this.Paketcuk = this.splitString(number);
                } else {
                    this.Paket = number;
                    this.Paketcuk = number;
                }

                this.hitungfunc();
                this.cekValidate();
            },

            masaaktiftoogle(e) {
                e.preventDefault()
                if (!$('#customSwitch3').is(":checked")) {
                    $('#masaaktif').slideDown(400);
                    $('#customSwitch3').prop('checked', true)
                } else {
                    $('#masaaktif').slideUp(400);
                    $('#customSwitch3').prop('checked', false)
                }
                this.cekValidate()
            },

            splitString(stringToSplit) {
                var arrayOfStrings = stringToSplit.split(',');
                var agest = arrayOfStrings[0] + "." + arrayOfStrings[1].substr(0, 2);
                return agest
            },

            splitTextString(stringToSplit) {
                var arrayOfStrings = stringToSplit.split(",");
                var afterComma = arrayOfStrings[1].split(",");
                if (arrayOfStrings) {
                    return arrayOfStrings[0] + "," + afterComma[0].substr(0, 2);
                } else {
                    return stringToSplit
                }
            },

            formatrupiahcreatedeposit(event) {
                var rupiah = event.target.value;
                var formattedrupiahcreate = this.newrupiahcreatedeposit(rupiah);
                this.Paket = formattedrupiahcreate
            },

            newrupiahcreatedeposit(angka, prefix) {
                /* Fungsi formatRupiah */
                var number_string = angka.replace(/[^\d]/g, "").toString(),
                    split = number_string.split(".,"),
                    sisa = split[0].length % 3,
                    rupiah = split[0].substr(0, sisa),
                    ribuan = split[0].substr(sisa).match(/\d{3}/gi);
                // tambahkan titik jika yang di input sudah menjadi angka ribuan
                if (ribuan) {
                    var separator = sisa ? "." : "";
                    rupiah += separator + ribuan.join(".");
                }

                rupiah = split[1] != undefined ? rupiah + "." + split[1] : rupiah;
                return prefix == undefined ? rupiah : rupiah ? "Rp." + rupiah : "";
            },

            onlynumberdiskon(event) {
                var nums = event.target.value;
                var number = nums.replace(/[^0-9,]+/, '');
                this.Diskon = number;
                this.max100();
                this.hitungfunc()
            },

            // splitString(stringToSplit) {
            //     var arrayOfStrings = stringToSplit.split('.');
            //     var agest = arrayOfStrings.join('')
            //     return agest
            // },

            max100() {
                var inputkomisi = this.Diskon;
                if (inputkomisi >= 100) {
                    this.Diskon = 100
                }
                this.decimal();
                this.hitungfunc();
                this.cekValidate()
            },

            decimal() {
                $('#diskon').keydown(function (e) {
                    //Get the occurence of decimal operator
                    var match = $(this).val().match(/\./g);
                    if (match != null) {
                        // Allow: backspace, delete, tab, escape and enter
                        if ($.inArray(e.keyCode, [46, 8, 9, 27, 13, 110]) !== -1 ||
                            // Allow: Ctrl+A
                            (e.keyCode == 65 && e.ctrlKey === true) ||
                            // Allow: home, end, left, right
                            (e.keyCode >= 35 && e.keyCode <= 39)) {
                            // let it happen, don't do anything
                            return;
                        }  // Ensure that it is a number and stop the keypress
                        else if ((e.shiftKey || (e.keyCode < 48 || e.keyCode > 57)) && (e.keyCode < 96 || e.keyCode > 105) && (e.keyCode == 188)) {
                            e.preventDefault();
                        }
                    } else {
                        // Allow: backspace, delete, tab, escape, enter and .
                        if ($.inArray(e.keyCode, [46, 8, 9, 27, 13, 110, 188]) !== -1 ||
                            // Allow: Ctrl+A
                            (e.keyCode == 65 && e.ctrlKey === true) ||
                            // Allow: home, end, left, right
                            (e.keyCode >= 35 && e.keyCode <= 39)) {
                            // let it happen, don't do anything
                            return;
                        }
                        // Ensure that it is a number and stop the keypress
                        if ((e.shiftKey || (e.keyCode < 48 || e.keyCode > 57)) && (e.keyCode < 96 || e.keyCode > 105)) {
                            e.preventDefault();
                        }
                    }
                });

                $('#diskon').keyup(function () {
                    var realValue = this.value
                    if ($(this).val().indexOf(',') != -1) {
                        if ($(this).val().split(",").length > 2) {
                            var stringData = this.value
                            var stringlenght = stringData.length
                            var setString = stringData.substring(0, stringlenght - 1)
                            this.value = setString
                        }
                        if ($(this).val().split(",")[1].length >= 2) {
                            if (isNaN(parseFloat(this.value))) {
                                return
                            }
                            var value = realValue.replace(",", ".")
                            var fakeValue = parseFloat(value).toFixed(2);
                            var fakeValueStr = fakeValue.toString()
                            this.value = fakeValueStr.replace(".", ",")
                        }
                    }
                })
            },

            onlynumberdurasi(event) {
                var nums = event.target.value;
                var number = nums.replace(/[^0-9]+/g, '');
                this.Masa_aktif = number;
                this.hitungfunc();
                this.formatrupiahcreatedurasideposit(event)
                this.cekValidate()
            },

            formatrupiahcreatedurasideposit(event) {
                var rupiah = event.target.value;
                rupiah = rupiah.replace(/[^0-9]+/g, '');
                var formattedrupiahcreate = this.newrupiahcreatedurasideposit(rupiah);
                this.Masa_aktif = formattedrupiahcreate
            },

            newrupiahcreatedurasideposit(angka, prefix) {
                /* Fungsi formatRupiah */
                var number_string = angka.replace(/[^,\d]/g, "").toString(),
                    split = number_string.split(","),
                    sisa = split[0].length % 3,
                    rupiah = split[0].substr(0, sisa),
                    ribuan = split[0].substr(sisa).match(/\d{3}/gi);
                // tambahkan titik jika yang di input sudah menjadi angka ribuan
                if (ribuan) {
                    var separator = sisa ? "." : "";
                    rupiah += separator + ribuan.join(".");
                }

                rupiah = split[1] != undefined ? rupiah + "," + split[1] : rupiah;
                return prefix == undefined ? rupiah : rupiah ? "Rp." + rupiah : "";
            },

            nameonly(event) {
                var nums = event.target.value;
                var number = nums.replace(/[^0-9A-Za-z_.,' -]+/, '');
                ;
                this.Nama_Paket_Deposit = number;
                this.cekValidate()
            },

            cekValidate() {
                return
                var NamaPaket = this.Nama_Paket_Deposit;
                var LayananTerhubung = this.selectedlayananedit;
                var IsiPaket = this.Paket;
                var Diskon = this.Diskon;
                var MasaAktif = this.Masa_aktif
                var lenPass = NamaPaket.length;
                //membuta data ke string karna undifined
                var stringMasaAKtif = MasaAktif.toString()
                var stringIsiPaket = IsiPaket.toString()
                var stringDiskon = Diskon.toString()
                if (lenPass >= 2 && LayananTerhubung !== '1' && stringIsiPaket.length >= 1) {
                    if ($('#customSwitch3').is(":checked") && (parseInt(this.Masa_aktif) === 0 || this.Masa_aktif === "")) {
                        $('#btnSimpanEditDeposit').prop('disabled', true);
                    } else {
                        $('#btnSimpanEditDeposit').prop('disabled', false);
                    }
                } else {
                    $('#btnSimpanEditDeposit').prop('disabled', true);
                }
            },
            back() {
                this.$emit('backtolistdeposit')
            },

            async myChangeEvent(idlayanan) {
                this.myValue = idlayanan;
                await this.gettahapandeposit();
                this.hitungfunc()
            },

            async gettahapandeposit() {
                $('#loadingPage').show();
                $('#loadingPage').addClass('overlayLoading');
                try {
                    const response = await this.$axios.get(this.$baseurl + '/masterData/meta/detail_layanan?idlayanan=' + this.myValue + '&idoutlet=' + this.setidoutletsetdeposit, this.requestHeaders)
                    if (response.data.status === true) {
                        this.satuan = response.data.data.layanan.satuan.nama;
                        this.HargaLayanan = response.data.data.harga;
                        $('#loadingPage').hide();
                        $('#loadingPage').removeClass('overlayLoading');
                    }
                } catch (e) {
                    this.$catch_error_response(e)
                    $('#loadingPage').removeClass('overlayLoading');
                    $('#loadingPage').hide();
                }
            },

            async getlayananselect() {
                $('#loadingPage').show();
                $('#loadingPage').addClass('overlayLoading');
                try {
                    const response = await this.$axios.get(this.$baseurl + '/masterData/meta/list_select_layanan_meta?idoutlet=' + this.setidoutletsetdeposit, this.requestHeaders)
                    if (response.data.status === true) {
                        $('#loadingPage').hide();
                        $('#loadingPage').removeClass('overlayLoading');
                        var layanan = response.data.data;
                        this.optionslayananedit.push({id: "", text: "Pilih Layanan"})
                        for (var i = 0; i < layanan.length; i++) {
                            this.optionslayananedit.push({
                                id: layanan[i].layanan.idlayanan,
                                text: layanan[i].layanan.nama_layanan
                            })
                        }
                    }
                } catch (e) {
                    this.$catch_error_response(e)
                    $('#loadingPage').removeClass('overlayLoading');
                    $('#loadingPage').hide();
                }
            },

            formatrupiahcreatehargalayanan(rupiah) {
                var formatrupiahcreatehargalayanan = this.newrupiahcreatedeposithargalayanan(rupiah);
                return formatrupiahcreatehargalayanan
            },

            newrupiahcreatedeposithargalayanan(angka, prefix) {
                /* Fungsi formatRupiah */
                var number_string = angka.toString().replace(/[^,\d]/g, ""),
                    split = number_string.split(","),
                    sisa = split[0].length % 3,
                    rupiah = split[0].substr(0, sisa),
                    ribuan = split[0].substr(sisa).match(/\d{3}/gi);
                // tambahkan titik jika yang di input sudah menjadi angka ribuan
                if (ribuan) {
                    var separator = sisa ? "." : "";
                    rupiah += separator + ribuan.join(".");
                }

                rupiah = split[1] != undefined ? rupiah + "," + split[1] : rupiah;
                return prefix == undefined ? rupiah : rupiah ? "Rp." + rupiah : "";
            },

            hitungfunc() {
                this.cekValidate()
                // var diskon;
                // var diskonStr;
                var hargaLayanan;
                // if (this.Diskon === null || this.Diskon === ""){
                //     diskon = 0
                // }else{
                //     diskonStr = this.Diskon;
                //     var newStr = diskonStr.toString().replace(",", '.');
                //     diskon = newStr
                // }
                if (this.HargaLayanan === null || this.HargaLayanan === "") {
                    hargaLayanan = 0
                } else {
                    hargaLayanan = this.HargaLayanan
                }

                var HargaDiskon = hargaLayanan * (parseFloat(this.Diskon.raw) / 100);
                var HagaSatuan = hargaLayanan - HargaDiskon;
                var Harga_Paket = HagaSatuan * parseFloat(this.Paketcuk);
                var Harga_Paket_Desimal = Harga_Paket.toString().replace(".", ",")
                this.Harga_Paket = this.formatrupiahcreatehargalayanan(Harga_Paket_Desimal);
                // this.Harga_Paket = Harga_Paket
            },

            hitungdiskon() {
                this.cekValidate();
                // var diskon;
                // var hargaLayanan;
                // if (this.Diskon === null || this.Diskon === ""){
                //     diskon = 0
                // }else{
                //     diskon = this.Diskon
                // }
                // if (this.HargaLayanan === null || this.HargaLayanan === ""){
                //     hargaLayanan = 0
                // }else{
                //     hargaLayanan = this.HargaLayanan
                // }
                var getdiskon
                var getdiskonFormatted
                var totalharga = this.HargaLayanan * parseFloat(this.Paketcuk);
                var hargadiskon = totalharga - this.Harga_Paket_Diskon;
                getdiskon = (hargadiskon / totalharga) * 100
                getdiskonFormatted = getdiskon.toFixed(2)
                getdiskonFormatted = getdiskonFormatted.toString().replace(".", ",")
                $("#diskonId").val(getdiskonFormatted)
                this.Diskon = {
                    raw: getdiskon,
                    formatted: getdiskonFormatted,
                }
            },

            formatrupiahdeposit(event) {
                var rupiah = event.target.value;
                var formattedrupiah = this.newrupiahdeposit(rupiah);
                this.Harga_Paket = formattedrupiah
            },

            newrupiahdeposit(angka, prefix) {
                /* Fungsi formatRupiah */
                var number_string = angka.replace(/[^,\d]/g, "").toString(),
                    split = number_string.split(","),
                    sisa = split[0].length % 3,
                    rupiah = split[0].substr(0, sisa),
                    ribuan = split[0].substr(sisa).match(/\d{3}/gi);
                // tambahkan titik jika yang di input sudah menjadi angka ribuan
                if (ribuan) {
                    var separator = sisa ? "." : "";
                    rupiah += separator + ribuan.join(".");
                }

                rupiah = split[1] != undefined ? rupiah + "," + split[1] : rupiah;
                return prefix == undefined ? rupiah : rupiah ? "Rp." + rupiah : "";
            },

            async detaildeposit() {
                $('#loadingPage').show();
                $('#loadingPage').addClass('overlayLoading');
                try {
                    const response = await this.$axios.get(this.$baseurl + '/masterData/meta/data_detail_deposit?iddeposit=' + this.dataiddeposit.iddeposit, this.requestHeaders)
                    if (response.data.status === true) {
                        $('#loadingPage').hide();
                        $('#loadingPage').removeClass('overlayLoading');
                        this.convertMiliseconds;
                        var nominal = response.data.data[0].harga_deposit;
                        var toRdeposit = this.newrupiahdeposit(nominal.toString());
                        this.Nama_Paket_Deposit = response.data.data[0].nama;
                        this.selectedlayananedit = response.data.data[0].layanan_idlayanan;
                        var rawJumlah = response.data.data[0].jumlah.toString()
                        this.Paket = rawJumlah.replace(".", ",");
                        var PaketCuk = response.data.data[0].jumlah;
                        this.Paketcuk = PaketCuk;
                        this.satuan = response.data.data[0].layanan.satuan.nama;
                        this.Masa_aktif = this.convertMiliseconds(response.data.data[0].masa_aktif);
                        if (this.Masa_aktif > 0 && this.Masa_aktif !== 10000) {
                            $("#label-durasi").click();
                        }
                        if (this.Masa_aktif === 10000) {
                            this.Masa_aktif = 0
                        }
                        this.Harga_Paket = toRdeposit;
                        this.Harga_Paket_Diskon = response.data.data[0].harga_deposit;
                        this.HargaLayanan = response.data.data[0].harga_layanan;
                        this.hitungdiskon();
                        this.hitungfunc();
                    } else {
                        $('#loadingPage').hide();
                        $('#loadingPage').removeClass('overlayLoading');
                    }
                } catch (e) {
                    this.$catch_error_response(e)
                    $('#loadingPage').removeClass('overlayLoading');
                    $('#loadingPage').hide();
                }
            },

            convertMiliseconds(miliseconds) {
                var days, hours, minutes, seconds, total_hours, total_minutes, total_seconds;

                total_seconds = parseInt(Math.floor(miliseconds / 1000));
                total_minutes = parseInt(Math.floor(total_seconds / 60));
                total_hours = parseInt(Math.floor(total_minutes / 60));
                days = parseInt(Math.floor(total_hours / 24));

                seconds = parseInt(total_seconds % 60);
                minutes = parseInt(total_minutes % 60);
                hours = parseInt(total_hours % 24);

                return days;
            },

            errorValidation() {
                if ($("#customSwitch3").is(":checked")) {
                    this.$v.Nama_Paket_Deposit.$touch()
                    this.$v.selectedlayananedit.$touch()
                    this.$v.Paketcuk.$touch()
                    this.$v.Diskon.$touch()
                    this.$v.Masa_aktif.$touch()
                    return this.$v.Nama_Paket_Deposit.$invalid ||
                        this.$v.selectedlayananedit.$invalid ||
                        this.$v.Paketcuk.$invalid ||
                        this.$v.Diskon.$invalid ||
                        this.$v.Masa_aktif.$invalid
                } else {
                    this.$v.Nama_Paket_Deposit.$touch()
                    this.$v.selectedlayananedit.$touch()
                    this.$v.Paketcuk.$touch()
                    this.$v.Diskon.$touch()
                    return this.$v.Nama_Paket_Deposit.$invalid ||
                        this.$v.selectedlayananedit.$invalid ||
                        this.$v.Paketcuk.$invalid ||
                        this.$v.Diskon.$invalid
                }
            },
            async editdeposit() {
                if (this.errorValidation()) {
                    this.$toast.error("Mohon Lengkapi Data Terlebih Dahulu")
                    return
                }
                this.isClicked1 = true
                $('#textBtn2').hide()
                $('#btnSimpanEditDeposit').prop('disabled', true);
                try {
                    const deposit = new FormData()
                    deposit.append('nama_paket', this.Nama_Paket_Deposit)
                    deposit.append('idlayanan', this.selectedlayananedit)
                    deposit.append('harga_layanan', this.HargaLayanan)
                    deposit.append('isi_paket', this.Paket)
                    deposit.append('harga_paket', this.Harga_Paket)
                    if (!$('#customSwitch3').is(":checked")) {
                        deposit.append('masa_aktif_hari', 10000)
                    } else {
                        deposit.append('masa_aktif_hari', this.Masa_aktif)
                    }
                    const response = await this.$axios.post(this.$baseurl + '/masterData/deposit/update_deposit?iddeposit=' + this.dataiddeposit.iddeposit, deposit, this.requestHeaders);
                    if (response.data.status === true) {
                        this.isClicked1 = false;
                        $('#textBtn2').show();
                        $('#btnSimpanEditDeposit').prop('disabled', false);
                        this.$toast.success(response.data.msg)
                        this.back()
                    } else {
                        this.isClicked1 = false;
                        $('#textBtn2').show();
                        $('#btnSimpanEditDeposit').prop('disabled', false);
                        this.$toast.error(response.data.msg)
                    }
                } catch (e) {
                    this.$catch_error_response(e)
                    this.isClicked1 = false;
                    $('#textBtn2').show();
                    $('#btnSimpanEditDeposit').prop('disabled', false);
                }

            },
            penjelasanMasaAktif() {
                $('#masaaktif').on('focus', function () {
                    $("#penjelasan-masa-aktif").slideDown();
                });
                $('#masaaktif').on('blur', function () {
                    $("#penjelasan-masa-aktif").slideUp();
                });
            }
        }
    }
</script>

<style scoped>
    .tooltip-inner {
        text-align: left !important;
    }
</style>